module.exports = __webpack_public_path__ + "static/img/getimage_en.2bf0793.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/getimage_en.png
// module id = L/af
// module chunks = 88